import { baseSeriesMark } from "../../base/constant";

export const progressLikeSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    group: {
        name: "group",
        type: "group"
    }
});
//# sourceMappingURL=constant.js.map
